import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class TermsAndCondition extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Terms & Condition
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Terms & Condition</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="about-section section-padding fix bg-cover">
                    <div className="container">
                        <div className="about-wrapper style-2">
                            <div className="row">
                                <div className="col-lg-12 mt-4 mt-lg-0">
                                    <div className="about-content">
                                        <div className="section-title mb-3 mxw-650">
                                            <div className="subtitle">
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span>Terms &amp; Condition</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title">Terms of uses for ITMES Trade Services</h2>
                                        </div>
                                        <h5 className="mb-3">
                                            PLEASE READ THIS DISCLAIMER CAREFULLY BEFORE PROCEEDING WITH
                                            REGISTRATION. BY REGISTERING ON THIS WEBSITE, YOU AGREE TO THE
                                            FOLLOWING TERMS:
                                        </h5>
                                        <p className="d-flex">
                                            <span className="width_40">1.</span>
                                            If you choose to use our Service, then you agree to the collection
                                            and use of information in relation with this policy. The Personal
                                            Information that we collect are used for providing and improving
                                            the Service of ITME events &amp; activities only
                                        </p>
                                        <p className="d-flex">
                                            <span className="width_40">2.</span>
                                            User Responsibility By registering, you acknowledge that:
                                        </p>
                                        <ul style={{ color: "#445375" }}>
                                            <li>
                                                You are responsible for providing accurate and truthful
                                                information during registration
                                            </li>
                                            <li>
                                                Your participation in any service, interaction, or event
                                                facilitated through this platform is at your own discretion and
                                                risk.
                                            </li>
                                        </ul>
                                        <p className="d-flex">
                                            <span className="width_40">3.</span>
                                            No Liability for Transactions or Disputes The platform is not a
                                            party to any agreements, transactions, or collaborations
                                            established through its services. Any disputes or disagreements
                                            arising from such interactions must be resolved directly between
                                            the involved parties without involving the platform. The platform
                                            disclaims all liability for:
                                        </p>
                                        <ul style={{ color: "#445375" }}>
                                            <li>
                                                Any financial loss, damages, or disputes resulting from trade
                                                missions, inquiries, exhibitions, knowledge sessions or any of
                                                our services.
                                            </li>
                                            <li>
                                                The quality, delivery, or legitimacy of any product or service
                                                exchanged between users.
                                            </li>
                                        </ul>
                                        <p className="d-flex">
                                            <span className="width_40">4.</span>
                                            <strong>Content and Intellectual Property</strong>
                                        </p>
                                        <ul style={{ color: "#445375" }}>
                                            <li>
                                                Users are responsible for the originality and legality of the
                                                content they share through the platform.
                                            </li>
                                            <li>
                                                The platform reserves the right to remove content deemed
                                                inappropriate, offensive, or infringing on intellectual property
                                                rights.
                                            </li>
                                        </ul>
                                        <p className="d-flex">
                                            <span className="width_40">5.</span>
                                            <strong>Privacy and Data Usage</strong>
                                        </p>
                                        <ul style={{ color: "#445375" }}>
                                            <li>
                                                Information provided during registration will be used to
                                                facilitate the services you opt into, improve user experience,
                                                and comply with legal requirements.
                                            </li>
                                            <li>
                                                Data may be shared with third-party service providers to enhance
                                                the services offered.
                                            </li>
                                            <li>
                                                By registering, you give your consent to the platform to verify
                                                the provided information submitted by you in the form, online or
                                                onsite via telephonic call or email. You also consent to receive
                                                promotional information via digital and offline channels,
                                                including but not limited to email, SMS, WhatsApp, print
                                                newsletters, and invitation cards
                                            </li>
                                            <li>
                                                Furthermore, you agree that the organizer may use your
                                                photographs captured during trade services events, including
                                                trade missions, exhibitions, or knowledge sessions, for future
                                                promotional activities and materials
                                            </li>
                                        </ul>
                                        <p className="d-flex">
                                            <span className="width_40">6.</span>
                                            Indemnification By registering, you agree to indemnify and hold
                                            the platform harmless from any claims, losses, or damages arising
                                            out of:
                                        </p>
                                        <ul style={{ color: "#445375" }}>
                                            <li>Your use of the services offered</li>
                                            <li>Any disputes with other users or third parties</li>
                                            <li>Violation of any applicable laws or third-party rights</li>
                                        </ul>
                                        <p className="d-flex">
                                            <span className="width_40">7.</span>
                                            Changes to Services and Terms The platform reserves the right to
                                            modify its services, terms, or policies without prior notice.
                                            Continued use of the platform after such changes constitutes
                                            acceptance of the updated terms
                                        </p>
                                        <h5>
                                            BY PROCEEDING WITH REGISTRATION, YOU CONFIRM THAT YOU HAVE READ,
                                            UNDERSTOOD, AND AGREED TO THIS DISCLAIMER.
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(TermsAndCondition));